import { render, staticRenderFns } from "./groupNews.vue?vue&type=template&id=bd2f6f10&scoped=true"
import script from "./groupNews.vue?vue&type=script&lang=js"
export * from "./groupNews.vue?vue&type=script&lang=js"
import style0 from "./groupNews.vue?vue&type=style&index=0&id=bd2f6f10&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd2f6f10",
  null
  
)

export default component.exports